export const ROOT = '/';
export const CREATE_URL = 'create';

//Auth
export const ROUTE_AUTH_BASE = '';
export const ROUTE_AUTH_FULL_PATH = `/${ROUTE_AUTH_BASE}`;
export const ROUTE_RESET_PASSWORD = 'reset-password';
export const ROUTE_SET_PASSWORD = 'register';
export const ROUTE_SUPPORT = 'support';
export const ROUTE_AUTH_URL = `${ROUTE_AUTH_BASE}/*`;

export const DASHBOARD_URL = '/dashboard';

export const SIMS_URL = 'sims';
export const SIMS_FULL_URL = `${DASHBOARD_URL}/${SIMS_URL}`;

export const PLAN_MANAGEMENT_URL = 'plan-management';
export const PLAN_MANAGEMENT_FULL_URL = `${DASHBOARD_URL}/${PLAN_MANAGEMENT_URL}`;

export const PLANS_URL = 'plans';
export const PLANS_FULL_URL = `${DASHBOARD_URL}/${PLAN_MANAGEMENT_URL}/${PLANS_URL}`;

export const ZONES_URL = 'zones';
export const ZONES_FULL_URL = `${DASHBOARD_URL}/${PLAN_MANAGEMENT_URL}/${ZONES_URL}`;

export const SUB_ACCOUNTS_URL = 'sub-accounts';
export const SUB_ACCOUNTS_FULL_URL = `${DASHBOARD_URL}/${SUB_ACCOUNTS_URL}`;

export const PROFILE_URL = 'profile';

export const USER_MANAGEMENT_URL = 'user-management';
export const USER_MANAGEMENT_FULL_URL = `${DASHBOARD_URL}/${USER_MANAGEMENT_URL}`;
export const USER_MANAGEMENT_USERS_URL = 'users';
export const USER_MANAGEMENT_ROLE_URL = 'roles';
export const USER_MANAGEMENT_USERS_LOGS_URL = 'users-logs';
export const NEW_ROLE_FULL_PATH = `${DASHBOARD_URL}/${USER_MANAGEMENT_URL}/${USER_MANAGEMENT_ROLE_URL}/new`;
export const NEW = 'new';

export const B2C_MANAGEMENT_URL = 'b2c-management';
export const B2C_MANAGEMENT_FULL_URL = `${DASHBOARD_URL}/${B2C_MANAGEMENT_URL}`;

export const B2C_USERS_URL = 'users';
export const B2C_USERS_FULL_URL = `${DASHBOARD_URL}/${B2C_MANAGEMENT_URL}/${B2C_USERS_URL}`;

export const B2C_PLANS_URL = 'plans';
export const B2C_PLANS_FULL_URL = `${DASHBOARD_URL}/${B2C_MANAGEMENT_URL}/${B2C_PLANS_URL}`;

export const B2C_DISCOUNTCODE_URL = 'discount-code';
export const B2C_DISCOUNTCODE_FULL_URL = `${DASHBOARD_URL}/${B2C_MANAGEMENT_URL}/${B2C_DISCOUNTCODE_URL}`;
export const NEW_DISCOUNTCODE_FULL_PATH = `${DASHBOARD_URL}/${B2C_MANAGEMENT_URL}/${B2C_DISCOUNTCODE_URL}/new`;

export const B2C_SALES_URL = 'sales';
export const B2C_SALES_FULL_URL = `${DASHBOARD_URL}/${B2C_MANAGEMENT_URL}/${B2C_SALES_URL}`;
